/**
 * @desc Snowmaking layers to import into the store
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

import layers from "./layers";

export default {
  modules: {
    layers
  },
  state: {
    name: "utilities",
    deptTitle: "Utilities",
    icon: "power_input",
    toggleAllButton: true,
  }
};
